import { Table, TableBody, TableRow, TableCell, styled } from '@mui/material'
import PreviewDom from 'components/DocumentDetail/PreviewDom'
import { DOC_TYPE } from 'config'
import { Document } from 'entities/Documents'
import { DocumentBuilder } from 'entities/DocumentsOcrBuilder'
import getOcrBuilderFields from 'entities/getOcrBuilderFields'
import { useHighlightContext } from 'hooks/useHighlightContext'
import { useMemo } from 'react'
import { getHighlightsPattern } from 'utils/highlights'

const Container = styled('div')(({ theme }) => ({
  height: 200,
  backgroundColor: theme.palette.grey[200],
  flexShrink: 0,
  '& .MuiTableCell-root': {
    backgroundColor: theme.palette.grey[200],
  },
}))

function CurrentPreview({ detail }: { detail: Document }) {
  const { hlKey, isMatch } = useHighlightContext()
  const [currentHighlights, srcs] = useMemo(() => {
    const highlights = detail.getHighlights()
    const fieldRegex = getHighlightsPattern(isMatch, hlKey)
    return [highlights.filter((x) => fieldRegex.test(x.name)), detail.getSrcs()]
  }, [detail, hlKey, isMatch])

  let label = ''
  if (detail.docInfo.documentType === DOC_TYPE.INVOICE) {
    label = currentHighlights?.[0]?.label || ''
  } else if (detail.docInfo.documentType === DOC_TYPE.OCR_BUILDER) {
    const fields = getOcrBuilderFields(detail as DocumentBuilder)
    label = fields.find((x) => x.name === hlKey)?.label || ''
  } else if (detail.docInfo.documentType === DOC_TYPE.ORDER_FORM) {
    label = currentHighlights?.[0]?.label || ''
  }
  return (
    <Container>
      <Table style={{ height: '100%' }}>
        <TableBody>
          <TableRow>
            <TableCell variant="head" sx={{ width: 15 * 8, height: 4 * 8 }}>
              項目
            </TableCell>
            <TableCell>{label}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant="head">イメージ</TableCell>
            <TableCell style={{ height: '100%' }}>
              <PreviewDom srcs={srcs} highlights={currentHighlights} hidden={!hlKey} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Container>
  )
}

export default CurrentPreview
